import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { makeStyles } from 'utils/styles';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React from 'react';
import UserManagement from './UserManagement';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.veryLight,
    padding: 10,
    width: '100%'
  },
  header: {
    backgroundColor: theme.palette.secondary.main
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    flexBasis: '33.33%',
    flexShrink: 0,
    //color: theme.palette.secondary.dark
    color: 'white'
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    // color: theme.palette.secondary.dark
    color: 'white'
  }
}));

const Topic = ({ classes, expanded, handleChange }) => (
  <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
    <AccordionSummary
      className={classes.header}
      expandIcon={<ExpandMoreIcon/>}
      aria-controls="panel1bh-content"
      id="panel1bh-header"
    >
      <Typography className={classes.heading}>GESTÃO DE UTILIZADORES</Typography>
      <Typography className={classes.secondaryHeading}>
        Gestão de utilizadores da aplicação, criação, remoção, etc ...
      </Typography>
    </AccordionSummary>
    <AccordionDetails>
      <UserManagement/>
    </AccordionDetails>
  </Accordion>
);

const Component = props => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState('panel1');

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>
      <Topic classes={classes} expanded={expanded} handleChange={handleChange}/>
    </div>
  );
};

export default Component;
